/**
 * #8257 — Colonne « Date d'inscription » de la liste des participants.
 *
 * Contrat cross-repo : `dateRegistered` est la Date BSON posée par @wilout/database-repository sur
 * chaque billet (guichet compris) et la clé de tri du serveur (api-control). `dateRequest` (chaîne
 * ISO aux formats mixtes, parfois un Moment/Dayjs sérialisé) ne sert plus que de repli d'affichage
 * tant qu'un billet n'est pas backfillé. Un billet sans date exploitable s'affiche à la sentinelle.
 */
export const UNDATED_PARTICIPANT_ISO = '2000-01-01T00:00:00.000Z';

interface SerializedMoment {
  _d?: string | Date;
  $d?: string | Date;
}

export interface ParticipantDates {
  dateRegistered?: string | Date | null;
  dateRequest?: string | Date | SerializedMoment | null;
}

function unwrapSerializedMoment(value: string | Date | SerializedMoment | null | undefined): string | Date | null {
  if (value === null || value === undefined) return null;
  if (typeof value === 'string' || value instanceof Date) return value;
  return value._d || value.$d || null;
}

/** « DD/MM/YYYY HHhMM » en heure locale du navigateur, sur dateRegistered puis dateRequest. */
export function formatRegistrationDate(participant: ParticipantDates): string {
  const rawDate = unwrapSerializedMoment(participant.dateRegistered || participant.dateRequest);
  let dateObj = new Date(rawDate || UNDATED_PARTICIPANT_ISO);
  if (isNaN(dateObj.getTime())) dateObj = new Date(UNDATED_PARTICIPANT_ISO);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${pad(dateObj.getDate())}/${pad(dateObj.getMonth() + 1)}/${dateObj.getFullYear()} ${pad(dateObj.getHours())}h${pad(dateObj.getMinutes())}`;
}
